import RegionUser from "@irati/auth/types/RegionUser"

export default function isSaml(identity: RegionUser | User) {
  try {
    const {source = ""} = identity
    return source.toLowerCase() === "saml"
  } catch (e) {
    return false
  }
}
